import React from 'react';
import GraphWidgetTopCard from "./GraphWidgetTopCard";
import { Spinner, Typography, WithInfoIcon } from 'seagull';
import styles from "./ThreeLineTopCard.module.scss";
export default function ThreeLineTopCard(_ref) {
  let {
    title,
    secondaryText,
    primaryText,
    titleInfo = '',
    secondaryInfo = '',
    loading,
    success,
    testid,
    linkTo
  } = _ref;
  return /*#__PURE__*/React.createElement(GraphWidgetTopCard, {
    className: styles.topCard,
    linkTo: linkTo
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": loading ? "".concat(testid, "-loading") : testid
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(WithInfoIcon, {
    showInfo: !!titleInfo,
    info: titleInfo,
    infoTestId: testid && "".concat(testid, "-info")
  }, /*#__PURE__*/React.createElement(Typography, {
    ellipsis: true,
    variant: "paragraph1",
    skin: success ? 'success' : 'standard'
  }, title))), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    weight: "normal",
    "data-testid": testid && "".concat(testid, "-primary")
  }, loading ? /*#__PURE__*/React.createElement(Spinner, {
    size: 30
  }) : primaryText), secondaryText && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(WithInfoIcon, {
    showInfo: !!secondaryInfo,
    info: secondaryInfo,
    size: "s"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2",
    skin: "secondary",
    "data-testid": testid && "".concat(testid, "-secondary")
  }, loading && /*#__PURE__*/React.createElement(Spinner, {
    size: 20
  }), secondaryText)))));
}